module.exports = __webpack_public_path__ + "media/images/imagem_generico_operador-ebaf927b280637938e7e612450724584.png";